import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import './ApproveModal.css';
import closeIcon from '../../../../assets/Admin/RequestImages/close-icon.svg';
import approveIcon from '../../../../assets/Admin/RequestImages/approve-icon.svg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { axiosInstance } from '../../../../utils/tokenUtils';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const customToast = message => {
  toast.custom(
    t => (
      <div className="flex bg-[#F1FFF4] shadow-lg rounded-lg mt-[40px]">
        <div className="flex-1 w-full p-4 flex items-center gap-4">
          <CheckCircleIcon style={{ color: '#7BCF8C' }} />
          <p className="text-sm font-medium text-gray-900">{message}</p>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="w-[14px] h-[14px] cursor-pointer rounded-full flex items-center justify-center border border-[#D5DEE3] p-2"
          >
            <CloseIcon style={{ color: '#D5DEE3', width: '14px', height: '14px' }} />
          </button>
        </div>
      </div>
    ),
    {
      duration: 3000,
      position: 'top-right',
    }
  );
};

const ApproveModal = ({ setOpenApproveModal, rowId, teacherName }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenApproveModal(false);
  };
  const handleApprove = async () => {
    try {
      const res = await axiosInstance.patch(`/admin/teachers/${rowId}/approval`, {
        approval_status: 'approved',
      });
      if (res?.status === 200) {
        setOpenApproveModal(false);
        navigate('/admin/request');
        customToast(`${teacherName} request accepted.`);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Modal
      open={true}
      // onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-[11%] py-4 border-b border-[#D5DEE3]">
          <Typography className="approve-application-text">Approve Application</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center gap-4 px-6 py-4 border-b border-[#D5DEE3]">
          <img src={approveIcon} alt="approve" className="h-[100px]" />
          <Typography className="approve-application-text">
            Are you sure you want to approve the application ?
          </Typography>
        </Box>
        <Box className="flex items-center justify-end gap-4 px-6 py-4">
          <button className="cancel-application-button-approve" onClick={handleClose}>
            Cancel
          </button>
          <button className="approve-application-button-approve" onClick={handleApprove}>
            Approve
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ApproveModal;
